<template>
    <div class=" tours">
        <div class="top">
            <div class="title">partner visa</div>
        </div>
        <div class="content">
            <div class="title">New Legend Premium Partner Visa Service</div>
            <el-carousel indicator-position="none" :interval="4000">
                <el-carousel-item v-for="item in pictures" :key="item">
                    <div class="pic" style="width: 100%;">
                        <el-image style="width: 100%" :src="item" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                            :preview-src-list="pictures" preview-teleported :initial-index="4" fit="cover" />
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pictures: [
            ],
        }
    },
    mounted() {
        this.getBannerFn()
    },
    methods: {
        getBannerFn() {
            this.$http.news_list({
                type_id: 860,
                pagesize: 100
            }).then(res => {
                let list = res.data;
                let pic = []
                list.forEach(item => {
                    pic.push(item.image_url)
                })
                this.pictures = pic;
            })
        },
    },
}
</script>
<style lang="less" scoped>
.tours {
    .content {
        padding: 20px;
        box-sizing: border-box;
        max-width: 1200px;
        margin: 30px auto;
    }

    .title {
        margin-bottom: 15px;
        font-size: 20px;
    }

    .big-bg,
    /deep/.el-carousel,
    /deep/.el-carousel__container,
    .pic {
        height: 620px !important;
        width: 100%;
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/migration.jpg');
        background-size: auto 100%;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #fff;
            text-shadow: 3px 3px 5px #222222;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: auto 110%;

            img {
                transform: scale(1.1);
            }
        }
    }


}


@media (max-width: 899px) {
    .tours {
        padding-bottom: 80px;

        .top {
            height: 200px;

            .title {
                font-size: 30px;
                width: 100%;
                text-align: center;
                padding: 0 20px;
                box-sizing: border-box;
            }
        }

        .content {
            display: block;
            margin: 20px auto;
            width: calc(100% - 20px);

        }

        .big-bg,
        /deep/.el-carousel,
        /deep/.el-carousel__container,
        .pic {
            height: 320px !important;
            width: 100%;
        }

    }
}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
    .tours {
        padding-bottom: 60px;

        .top {
            height: 160px;

            .title {
                font-size: 24px;
                padding: 0 15px;
            }
        }

        .content {
            margin: 15px auto;
            width: calc(100% - 15px);

        }

        .big-bg,
        /deep/.el-carousel,
        /deep/.el-carousel__container,
        .pic {
            height: 180px !important;
            width: 100%;
        }


    }
}
</style>


// WEBPACK FOOTER //
// src/views/en/spouse.vue